var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 44,
    viewBox: "0 0 75 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8062 19.2919C19.1222 19.7029 18.5824 19.4092 18.5514 19.1398C18.5054 18.7391 19.7636 18.0041 21.3307 17.762C21.6996 17.6982 22.0187 17.6798 22.395 17.683C23.2273 17.6901 24.0576 17.8246 24.6354 18.2997C24.7851 16.9355 23.5336 16.1473 23.1024 16.0525C21.8814 15.7841 19.7225 15.6866 18.1886 16.1167C16.3278 16.7945 15.2799 18.3625 15.3776 19.3907C15.6434 20.3524 15.9725 20.8501 17.6422 20.9019C18.5312 20.9294 19.7763 20.1688 19.8063 19.2918L19.8062 19.2919Z",
    fill: "#FF5B00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1207 8.81991C25.1277 6.56183 24.0373 2.73621 22.9527 1.75369C21.8006 0.710059 21.0293 0.141362 19.1788 0.000164007C15.0032 -0.0207727 10.0948 1.96176 6.85852 6.55869C1.6417 13.9685 -0.820725 25.1375 0.243634 32.2869C0.722659 35.0259 2.10821 36.8182 2.587 37.0813C3.03249 37.326 4.93162 34.6375 4.39773 32.617C2.72207 27.1026 5.50274 15.4879 8.93196 10.2728C11.5003 6.36735 14.6207 3.80086 18.3323 3.43354C19.4371 3.32423 20.4746 3.38579 21.4842 3.85724C23.1347 4.62795 24.1298 6.52347 24.121 8.81859L24.1207 8.81991Z",
    fill: "#FF5B00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5658 5.41238C12.7744 5.41238 10.4166 9.86983 8.92189 14.4245C7.94377 17.4051 7.03835 20.8529 6.31962 23.9795C5.44884 27.7681 4.80502 31.0714 4.39814 32.6187C4.20053 33.3703 3.45171 36.0609 2.67422 36.0609C1.99512 36.0609 0.784541 34.4861 0.244141 32.2886C0.470184 33.7876 0.96012 35.7286 1.84288 37.0859C2.48428 38.072 3.33411 38.7435 4.43558 38.7435C5.99589 38.7435 7.33271 38.1884 8.56853 36.8204C9.61567 35.6614 10.5135 33.8617 11.3262 31.1835C13.2435 24.8657 13.6793 22.6473 14.6204 19.5459C15.2033 17.6251 15.8009 15.7502 16.4734 14.1001C18.0395 10.2575 19.5863 8.55267 21.3361 7.65218C21.0462 6.56554 20.0996 5.41199 17.5656 5.41199L17.5658 5.41238Z",
    fill: "#F41D1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.366 37.9809C12.2727 38.142 9.87167 37.9817 8.29997 36.4875C7.8266 36.0273 7.45694 35.361 7.43807 34.4818C7.41907 33.5948 7.87246 32.4055 8.72864 31.7959C8.9667 32.8216 10.1389 34.8441 13.2145 35.4481C15.732 35.9425 17.6808 35.3398 19.4543 33.8669C19.5143 33.9908 16.5768 37.8108 14.3659 37.981L14.366 37.9809Z",
    fill: "#FF5B00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29907 36.4886C8.81147 36.9967 9.41153 37.4705 10.1085 37.8684C11.5767 38.7066 13.4366 39.236 15.5431 39.236C24.7868 39.236 30.363 30.3434 30.9551 23.4907C31.2671 19.8792 29.6587 17.399 26.9634 16.1761C25.8415 15.6764 24.2023 15.308 22.6467 15.3565C21.0772 15.4053 19.141 15.7348 18.1871 16.1171C20.9899 15.7388 23.2742 16.5825 24.1188 19.568C24.5689 21.159 24.5116 22.5625 24.4538 23.5367C24.2566 26.8601 22.5703 31.1114 19.4534 33.8681C18.0603 35.1002 16.3923 36.1106 14.4041 36.696C12.1278 37.3663 10.0052 37.4393 8.29907 36.4887V36.4886Z",
    fill: "#F41D1D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1207 8.81989C23.9243 11.0548 23.4298 13.4096 22.6472 15.3547C22.2749 16.2799 21.8425 17.0712 21.3298 17.7606C20.8787 18.3672 20.363 18.9012 19.8053 19.2905C19.6497 19.3991 19.4927 19.4469 19.3286 19.5343C17.523 20.4952 15.8085 20.3115 15.3806 19.404C15.3917 20.6796 16.6803 21.8582 18.6877 21.8582C20.3526 21.8582 22.3345 21.1752 24.6207 19.1369C25.4396 18.4068 26.2426 17.3707 26.9639 16.1746C28.2604 14.0245 29.2626 11.3296 29.4037 8.76939C29.4681 7.60214 29.383 6.36858 29.0357 5.3418C27.8432 1.81628 24.0646 0.097511 19.1788 0.000488281C22.2618 0.418897 24.5732 3.67163 24.1208 8.82016L24.1207 8.81989Z",
    fill: "#F41D1D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M21.4849 3.85861C23.1353 4.62936 24.1305 6.52484 24.1216 8.81996C24.5741 3.67143 22.2629 0.41873 19.1798 0.00028605C15.0042 -0.0206488 10.0958 1.96188 6.85937 6.55881C1.64254 13.9687 -0.819883 25.1377 0.244295 32.287C0.784894 34.4846 1.99541 36.0593 2.67456 36.0593C3.45203 36.0593 4.20085 33.3687 4.39853 32.6171C2.72284 27.1027 5.50343 15.488 8.93258 10.273C11.5009 6.36748 14.6215 3.80098 18.3329 3.43367C19.4377 3.32437 20.4752 3.38592 21.4846 3.85737L21.4849 3.85861Z",
    fill: "url(#paint0_linear_121_2554)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M19.3292 19.5358C19.4934 19.4484 19.6504 19.4006 19.8059 19.292C19.1219 19.703 18.5821 19.4093 18.5511 19.14C18.5051 18.7391 19.7633 18.0042 21.3305 17.7621C21.5817 17.4244 21.82 17.0522 22.0345 16.661C21.5896 16.4066 21.0936 16.2322 20.5585 16.1335C19.8313 15.9993 19.0317 16.003 18.1882 16.1169C16.3273 16.7946 15.2795 18.3627 15.3771 19.3909C15.3787 19.3962 15.3804 19.4011 15.382 19.4065C15.8109 20.313 17.5245 20.4961 19.3291 19.5357L19.3292 19.5358Z",
    fill: "url(#paint1_linear_121_2554)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M19.3292 19.5358C19.4934 19.4484 19.6504 19.4006 19.8059 19.292C19.1219 19.703 18.5821 19.4093 18.5511 19.14C18.5051 18.7392 19.7633 18.0042 21.3305 17.7621C21.5817 17.4244 21.82 17.0522 22.0345 16.661C21.5908 16.4073 21.0919 16.2323 20.5585 16.1335C19.8301 15.9985 19.0333 16.0028 18.1882 16.1169C16.3273 16.7946 15.2795 18.3627 15.3771 19.3909C15.3787 19.3962 15.3804 19.4011 15.382 19.4065C15.8109 20.313 17.5245 20.4961 19.3291 19.5357L19.3292 19.5358Z",
    fill: "url(#paint2_radial_121_2554)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M14.4041 36.6945C16.3923 36.1092 18.0604 35.0986 19.4533 33.8666C17.6797 35.3395 15.731 35.9422 13.2135 35.4478C10.138 34.8438 8.9656 32.8213 8.72765 31.7957C7.87155 32.4052 7.41811 33.5945 7.4371 34.4816C7.45599 35.3607 7.82558 36.0271 8.29903 36.4873C10.0052 37.4379 12.1277 37.3649 14.4041 36.6946L14.4041 36.6945Z",
    fill: "url(#paint3_linear_121_2554)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M8.29907 36.4886C8.81147 36.9967 9.41153 37.4705 10.1085 37.8684C11.5767 38.7066 13.4366 39.236 15.5431 39.236C24.7868 39.236 30.363 30.3434 30.9551 23.4907C31.2671 19.8792 29.6587 17.399 26.9634 16.1761C25.8415 15.6764 24.2023 15.308 22.6467 15.3565C21.0772 15.4053 19.141 15.7348 18.1871 16.1171C20.9899 15.7388 23.2742 16.5825 24.1188 19.568C24.5689 21.159 24.5116 22.5625 24.4538 23.5367C24.2566 26.8601 22.5703 31.1114 19.4534 33.8681C18.0603 35.1002 16.3923 36.1106 14.4041 36.696C12.1278 37.3663 10.0052 37.4393 8.29907 36.4887V36.4886Z",
    fill: "url(#paint4_linear_121_2554)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M24.1207 8.81989C23.9243 11.0548 23.4298 13.4096 22.6472 15.3547C22.2749 16.2799 21.8425 17.0712 21.3298 17.7606C20.8787 18.3672 20.363 18.9012 19.8053 19.2905C19.6497 19.3991 19.4927 19.4469 19.3286 19.5343C17.523 20.4952 15.8085 20.3115 15.3806 19.404C15.3917 20.6796 16.6803 21.8582 18.6877 21.8582C20.3526 21.8582 22.3345 21.1752 24.6207 19.1369C25.4396 18.4068 26.2426 17.3707 26.9639 16.1746C28.2604 14.0245 29.2626 11.3296 29.4037 8.76939C29.4681 7.60214 29.383 6.36858 29.0357 5.3418C27.8432 1.81628 24.0646 0.097511 19.1788 0.000488281C22.2618 0.418897 24.5732 3.67163 24.1208 8.82016L24.1207 8.81989Z",
    fill: "url(#paint5_linear_121_2554)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M24.1208 8.81986C23.9244 11.0548 23.4297 13.4096 22.6472 15.3547C24.2029 15.3063 25.8421 15.6747 26.9639 16.1743C28.2604 14.0243 29.2626 11.3293 29.4037 8.76915C29.468 7.60186 29.383 6.36815 29.0357 5.34156C27.8432 1.81604 24.0644 0.0972669 19.179 0.000244141C22.262 0.418671 24.5734 3.67139 24.1208 8.81992L24.1208 8.81986Z",
    fill: "url(#paint6_linear_121_2554)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M18.6878 21.8593C19.3593 21.8593 20.0861 21.7476 20.8612 21.4802C21.8642 21.1341 22.95 20.5275 24.1193 19.5675C23.8508 18.6235 23.4348 17.8861 22.9063 17.3395C22.6421 17.0662 22.3515 16.8435 22.0338 16.6608C21.818 17.0533 21.5822 17.4225 21.3297 17.7618C20.8786 18.3684 20.363 18.9024 19.8052 19.2917C19.6497 19.4003 19.4927 19.4481 19.3286 19.5355C17.523 20.4964 15.8085 20.3127 15.3806 19.4052C15.3917 20.6807 16.6802 21.8593 18.6877 21.8593L18.6878 21.8593Z",
    fill: "url(#paint7_linear_121_2554)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M7.43725 34.4812C7.41826 33.5942 7.87168 32.4049 8.72779 31.7953C8.8647 32.3854 9.3163 33.3097 10.256 34.0996C10.6309 33.2687 10.9848 32.3041 11.3253 31.1824C13.2426 24.8646 13.6782 22.6462 14.6194 19.5448C15.2023 17.624 15.7998 15.7491 16.4722 14.099C18.0382 10.2564 19.5852 8.55157 21.3349 7.65108C21.045 6.56446 20.0983 5.41089 17.5644 5.41089C12.7728 5.41089 10.4152 9.86833 8.92048 14.423C7.94238 17.4038 7.03694 20.8514 6.31821 23.9782C5.44748 27.7668 4.80368 31.0701 4.39691 32.6174C4.19923 33.3689 3.4504 36.0596 2.67294 36.0596C1.99385 36.0596 0.783437 34.4848 0.242676 32.2873C0.468791 33.7862 0.958709 35.7273 1.84149 37.0846C2.48287 38.0707 3.33268 38.7422 4.43418 38.7422C5.31693 38.7422 6.14309 38.5647 6.9266 38.143C7.46402 37.8537 7.94043 37.4716 8.37468 37.0248C8.45671 36.9404 8.53637 36.8557 8.6043 36.7759C8.49467 36.6765 8.37999 36.5671 8.29872 36.4867C8.1435 36.333 8.01022 36.1731 7.89798 36.0025C7.7912 35.8401 7.70343 35.6678 7.63438 35.4932C7.51767 35.1981 7.44521 34.8724 7.43679 34.4809L7.43725 34.4812Z",
    fill: "url(#paint8_linear_121_2554)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M7.43725 34.4812C7.41826 33.5942 7.87168 32.4049 8.72779 31.7953C8.8647 32.3854 9.3163 33.3097 10.256 34.0996C10.4978 33.5638 10.8916 32.6113 11.3253 31.1824C13.2426 24.8646 13.6782 22.6462 14.6194 19.5448C15.2023 17.624 15.7998 15.7491 16.4722 14.099C18.0382 10.2564 19.5852 8.55157 21.3349 7.65108C21.045 6.56446 20.0983 5.41089 17.5644 5.41089C12.7728 5.41089 10.4152 9.86833 8.92048 14.423C7.94238 17.4038 7.03694 20.8514 6.31821 23.9782C5.44748 27.7668 4.80368 31.0701 4.39691 32.6174C4.19923 33.3689 3.4504 36.0596 2.67294 36.0596C1.99385 36.0596 0.783437 34.4848 0.242676 32.2873C0.468791 33.7862 0.958709 35.7273 1.84149 37.0846C2.48287 38.0707 3.33268 38.7422 4.43418 38.7422C5.33113 38.7422 6.15405 38.5588 6.9266 38.143C7.47205 37.8494 7.94717 37.4638 8.38108 37.0182C8.46747 36.9295 8.54558 36.8499 8.6043 36.7758C8.50464 36.6849 8.39905 36.5863 8.29872 36.4867C8.26411 36.4523 8.23047 36.4174 8.19745 36.3832C8.08761 36.2619 7.98649 36.1368 7.89799 36.0024C7.79285 35.8428 7.70502 35.6711 7.63439 35.4932C7.51135 35.1832 7.44465 34.8457 7.43681 34.4809L7.43725 34.4812Z",
    fill: "url(#paint9_radial_121_2554)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6569 38.4687C36.7035 33.2074 42.2072 26.6661 46.2147 22.648C48.5523 20.3045 49.1371 17.4446 48.2271 16.8758C47.8841 16.6615 46.9595 16.5345 44.2893 19.0284C42.7704 20.576 40.9099 22.7913 39.5494 24.5068C38.413 26.0182 37.1502 28.5135 36.3063 31.5631C35.527 34.3786 35.0885 37.7312 35.6569 38.4687H35.6569Z",
    fill: "#FF5B00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0103 19.2847C41.0103 16.9937 38.8583 15.7911 36.4752 15.7911C35.7903 15.7911 35.2327 15.8712 34.9998 16.0173C35.2652 17.4613 33.9475 21.2509 32.5753 25.1862C31.2185 29.0772 29.8086 33.1262 29.8086 35.2504C29.8086 37.5175 31.8596 38.7389 34.1824 38.7389C34.8456 38.7389 35.4191 38.6409 35.6575 38.469C35.2828 36.6082 37.0589 31.7581 38.6567 27.2722C39.871 23.8628 41.0103 20.6871 41.0103 19.2847Z",
    fill: "#F41D1D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2215 25.1963C56.6882 27.9872 52.1477 34.8622 48.9324 35.2975C48.5367 35.4528 48.7974 37.1386 50.0922 37.7173C51.1582 38.1938 52.2213 37.6457 53.2238 37.0745C55.2094 35.6087 58.5574 32.3686 60.5155 28.6432C60.8443 27.5368 59.0811 25.4968 58.2215 25.1963V25.1963Z",
    fill: "#FF5B00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9201 34.6077C48.9566 33.7339 49.2002 32.6004 49.5426 31.4762C49.8294 30.5348 50.1973 29.5184 50.4847 28.7377C51.889 24.9221 53.8492 20.9835 53.8492 18.836C53.8492 16.9123 51.6441 15.7913 49.5493 15.7913C48.1617 15.7913 46.944 16.3562 44.29 19.0288C45.4984 18.1144 46.678 17.1651 47.2528 17.3963C48.2439 17.7948 46.586 21.6167 45.4227 24.9151C44.4325 27.7226 43.0802 32.0514 44.0863 35.2155C44.8056 37.4776 46.7199 38.74 48.9881 38.74C50.8884 38.74 52.3477 37.7577 53.2245 37.075C51.0955 37.8569 49.093 37.4802 48.9331 35.298C48.9161 35.0643 48.9145 34.7478 48.9203 34.6078L48.9201 34.6077Z",
    fill: "#F41D1D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M46.2696 22.5892C47.2101 20.0308 48.0132 17.7023 47.2516 17.396C46.6767 17.1649 45.4972 18.1142 44.2888 19.0285C42.8203 20.5248 41.0367 22.6415 39.6901 24.3308C39.3694 25.2657 39.0181 26.2545 38.6557 27.272C37.0579 31.758 35.2818 36.6082 35.6563 38.4688C36.7028 33.2076 42.2065 26.6662 46.2141 22.6482C46.2334 22.6287 46.2503 22.6087 46.2695 22.5892L46.2696 22.5892Z",
    fill: "url(#paint10_linear_121_2554)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M58.2214 25.1963C56.6882 27.9872 52.1477 34.8624 48.9324 35.2975C49.0923 37.4797 51.0947 37.8564 53.2238 37.0745C55.2094 35.6088 58.5573 32.3686 60.5155 28.6433C60.8442 27.5368 59.0811 25.4968 58.2214 25.1963V25.1963Z",
    fill: "url(#paint11_linear_121_2554)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M41.0103 19.2847C41.0103 16.9937 38.8583 15.7911 36.4752 15.7911C35.7903 15.7911 35.2327 15.8712 34.9998 16.0173C35.2652 17.4613 33.9475 21.2509 32.5753 25.1862C31.2185 29.0772 29.8086 33.1262 29.8086 35.2504C29.8086 37.5175 31.8596 38.7389 34.1824 38.7389C34.8456 38.7389 35.4191 38.6409 35.6575 38.469C35.2828 36.6082 37.0589 31.7581 38.6567 27.2722C39.871 23.8628 41.0103 20.6871 41.0103 19.2847Z",
    fill: "url(#paint12_linear_121_2554)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M48.9201 34.6077C48.9566 33.7339 49.2002 32.6004 49.5426 31.4762C49.8294 30.5348 50.1973 29.5184 50.4847 28.7377C51.889 24.9221 53.8492 20.9835 53.8492 18.836C53.8492 16.9123 51.6441 15.7913 49.5493 15.7913C48.1617 15.7913 46.944 16.3562 44.29 19.0288C45.4984 18.1144 46.678 17.1651 47.2528 17.3963C48.2439 17.7948 46.586 21.6167 45.4227 24.9151C44.4325 27.7226 43.0802 32.0514 44.0863 35.2155C44.8056 37.4776 46.7199 38.74 48.9881 38.74C50.8884 38.74 52.3477 37.7577 53.2245 37.075C51.0955 37.8569 49.093 37.4802 48.9331 35.298C48.9161 35.0643 48.9145 34.7478 48.9203 34.6078L48.9201 34.6077Z",
    fill: "url(#paint13_linear_121_2554)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6302 25.1909C72.2375 25.9342 71.8353 26.6874 71.3999 27.3204C71.0387 27.8454 70.5961 28.3845 70.0733 28.9288C69.3596 29.6719 68.4696 30.4308 67.3368 31.0352C66.4611 31.5026 65.4468 31.8692 64.2157 32.1177C63.319 32.2986 62.3646 32.5677 61.2649 32.894C57.9708 33.8997 52.9077 35.8685 52.9077 39.3107C52.9976 39.7089 53.0977 40.5209 53.7623 40.9621C54.6257 41.5354 55.54 41.7564 55.8742 41.622C55.8742 40.0034 56.7739 38.8224 58.0719 37.9832C59.0733 37.3357 60.1479 37 61.2637 36.6757C62.5655 36.2974 63.8174 36.0693 64.9876 35.8402C69.8169 34.8948 72.5422 32.6294 74.4156 29.6051C74.6226 29.2709 74.8707 28.8227 74.9792 28.6333C75.1952 27.6125 73.6702 25.5989 72.63 25.1911L72.6302 25.1909Z",
    fill: "#FF5B00"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5315 16.8889C65.084 16.6529 63.7897 17.6442 63.2558 19.0534C62.5835 20.8281 63.0877 21.9778 64.2204 21.8607C64.9164 20.0529 65.3817 18.2976 65.5315 16.8889H65.5315Z",
    fill: "#FF5B00"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5315 16.8889C65.5814 15.9294 63.9667 14.9777 62.226 14.7255C61.2086 14.5781 60.1457 14.6728 59.3536 15.1365C57.7047 16.1017 57.0674 18.6488 57.1165 20.2764C57.2785 25.6426 61.0673 29.2538 61.4278 34.1011C61.6418 36.9794 60.6135 39.138 59.0469 40.2513C58.429 40.6903 57.7275 40.981 56.9778 41.0687C55.5363 41.2372 53.5527 40.5226 52.9093 39.31C52.7405 41.7108 55.1995 43.8225 58.8586 43.8225C64.0987 43.8225 67.8123 39.2906 67.8123 34.3235C67.8123 33.1547 67.6434 32.0775 67.3384 31.0347C66.824 29.4174 66.0078 27.7173 65.3262 25.9253C64.8268 24.6125 64.4007 23.2315 64.2202 21.8607C63.938 19.6729 64.5471 17.7098 65.5314 16.8889L65.5315 16.8889Z",
    fill: "#F41D1D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M55.9142 41.0488C56.0146 40.3381 56.3011 39.7171 56.7198 39.1831C57.0826 38.7206 57.5443 38.3241 58.0728 37.9824C58.7175 37.5656 59.3924 37.278 60.0892 37.0395C60.4702 36.909 60.872 36.789 61.2647 36.6748C61.3137 36.4536 61.3528 36.225 61.3832 35.9912C61.4597 35.4034 61.4772 34.7761 61.427 34.1011C61.3964 33.6902 61.3414 33.2891 61.2659 32.894C60.9127 33.0019 60.5431 33.1186 60.1577 33.2493C58.9708 33.6516 57.6703 34.1639 56.5026 34.8068C54.5127 35.9024 52.9084 37.3747 52.9084 39.3099C53.4034 40.2429 54.6897 40.8808 55.9142 41.0488L55.9142 41.0488Z",
    fill: "url(#paint14_linear_121_2554)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M64.2199 21.8611C64.9159 20.0535 65.3811 18.298 65.531 16.8893C64.5468 17.7104 63.9376 19.6733 64.2199 21.8611Z",
    fill: "url(#paint15_linear_121_2554)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M72.6303 25.1909C72.2375 25.9342 71.8354 26.6874 71.4 27.3204C71.0388 27.8454 70.5962 28.3845 70.0734 28.9287C69.3596 29.6718 68.4697 30.4308 67.3369 31.0352C67.6419 32.0781 67.8109 33.1553 67.8109 34.3241C67.8109 34.5727 67.8014 34.8219 67.7831 35.0678C70.9335 33.9019 72.9388 31.9896 74.4159 29.6049C74.6228 29.2708 74.8709 28.8225 74.9794 28.6331C75.1954 27.6124 73.6704 25.5987 72.6303 25.1909H72.6303Z",
    fill: "url(#paint16_linear_121_2554)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M65.5315 16.8889C65.5814 15.9294 63.9667 14.9777 62.226 14.7255C61.2086 14.5781 60.1457 14.6728 59.3536 15.1365C57.7047 16.1017 57.0674 18.6488 57.1165 20.2764C57.2785 25.6426 61.0673 29.2538 61.4278 34.1011C61.6418 36.9794 60.6135 39.138 59.0469 40.2513C58.429 40.6903 57.7275 40.981 56.9778 41.0687C55.5363 41.2372 53.5527 40.5226 52.9093 39.31C52.7405 41.7108 55.1995 43.8225 58.8586 43.8225C64.0987 43.8225 67.8123 39.2906 67.8123 34.3235C67.8123 33.1547 67.6434 32.0775 67.3384 31.0347C66.824 29.4174 66.0078 27.7173 65.3262 25.9253C64.8268 24.6125 64.4007 23.2315 64.2202 21.8607C63.938 19.6729 64.5471 17.7098 65.5314 16.8889L65.5315 16.8889Z",
    fill: "url(#paint17_linear_121_2554)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_121_2554",
    x1: -1.62208,
    y1: 46.1161,
    x2: 23.1767,
    y2: -10.7459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15418,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21487,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3461,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66512,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83025,
    stopColor: "#CBD23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_121_2554",
    x1: 21.1125,
    y1: 14.2684,
    x2: 16.9768,
    y2: 20.1031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16331,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34707,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74442,
    stopColor: "#CBD23B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_121_2554",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.1969 10.5486) scale(11.1754 11.1754)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.70797,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89668,
    stopColor: "#CBD23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_121_2554",
    x1: 7.82914,
    y1: 32.3735,
    x2: 16.127,
    y2: 36.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03106,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16191,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44485,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61676,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96326,
    stopColor: "#CBD23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_121_2554",
    x1: 29.4294,
    y1: 8.61512,
    x2: 14.0038,
    y2: 44.0141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14324,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22075,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38833,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63535,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93975,
    stopColor: "#CBD23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_121_2554",
    x1: 27.8585,
    y1: -2.67115,
    x2: 15.7778,
    y2: 24.9748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08567,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17082,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35493,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75017,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93771,
    stopColor: "#CBD23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_121_2554",
    x1: 20.3689,
    y1: 16.3779,
    x2: 22.4936,
    y2: 10.3103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16481,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41633,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96017,
    stopColor: "#CBD23B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_121_2554",
    x1: 23.4573,
    y1: 15.5668,
    x2: 20.126,
    y2: 19.0863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.20076,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4301,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92597,
    stopColor: "#CBD23B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_121_2554",
    x1: 18.5173,
    y1: -2.3995,
    x2: 1.60363,
    y2: 46.5713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08715,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16896,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34584,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64625,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89365,
    stopColor: "#CBD23B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_121_2554",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.11536 34.9761) rotate(-125.994) scale(6.63967 5.0265)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15235,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95642,
    stopColor: "#CBD23B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_121_2554",
    x1: 30.89,
    y1: 38.4113,
    x2: 53.8555,
    y2: 13.9654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16759,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27087,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49419,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58628,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79432,
    stopColor: "#CBD23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_121_2554",
    x1: 48.7714,
    y1: 39.5343,
    x2: 60.5637,
    y2: 25.2682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05447,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22508,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59397,
    stopColor: "#CBD23B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_121_2554",
    x1: 38.924,
    y1: 2.23531,
    x2: 32.4655,
    y2: 48.0486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19577,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27417,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44369,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85095,
    stopColor: "#CBD23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_121_2554",
    x1: 52.3226,
    y1: 2.74595,
    x2: 45.8649,
    y2: 48.5645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24112,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29913,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42457,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62868,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82965,
    stopColor: "#CBD23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_121_2554",
    x1: 52.9984,
    y1: 40.022,
    x2: 62.4762,
    y2: 33.7616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02975,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16947,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47158,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62893,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91456,
    stopColor: "#CBD23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_121_2554",
    x1: 63.7936,
    y1: 18.7367,
    x2: 66.0678,
    y2: 20.0798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03106,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33075,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97874,
    stopColor: "#CBD23B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_121_2554",
    x1: 64.626,
    y1: 32.5399,
    x2: 77.458,
    y2: 27.0231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12638,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2927,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65233,
    stopColor: "#CBD23B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_121_2554",
    x1: 64.1099,
    y1: 7.98923,
    x2: 58.7442,
    y2: 49.6972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10678,
    stopColor: "#CBD23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18735,
    stopColor: "#CBD23B",
    stopOpacity: 0.68377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36157,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65808,
    stopColor: "#CBD23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90648,
    stopColor: "#CBD23B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.38bdfae79541cf896b7e4716b8ebf7ca.svg";
export { ForwardRef as ReactComponent };